import { grey } from "@mui/material/colors";

const styles = {
  page: {
    pt: 4,
    pb: { xs: 8, md: 4 },
    px: { xs: 2, md: 10 },
  },
  header: { textAlign: "center", fontSize: { xs: 20, md: 40 } },
  button: (tabWidth: number, toolBarOpen: boolean) => ({
    position: "fixed",
    right: {
      xs: 30,
      sm: toolBarOpen ? 30 + tabWidth : 30,
      md: toolBarOpen ? 100 + tabWidth : 100,
    },
    bottom: { xs: 80, md: 50 },
  }),
  fieldContainer: {
    mb: 2,
  },
  questionBox: {
    border: `1px solid ${grey[300]}`,
    borderRadius: "16px",
    p: 2,
    width: "100%",
    mb: 2,
  },
  helperText: {
    mb: 0.5,
  },
  textField: {
    mb: 2,
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
};
export default styles;
